import { useEffect } from "react";
import { useMenuTypeDispatch } from "../../../../../context/MenuTypeContext";
import { hideMenuTypeTabs, hideSchoolDrowdown, showMenuTypeTabs, showSchoolDrowdown } from "../../../../../actions/menuTypeAction";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { useState } from "react";
import VendorForm from "./vendorForm";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { saveUserRec } from "../../../../../actions/usersAction";
import { toast } from "react-toastify";
import { useAuthState } from "../../../../../context";
import { addNewVendorRec, saveVendor } from "../../../../../actions/vendorAction";

const VendorRec = (props) => {
    const dispatch = useMenuTypeDispatch();
    const location = useLocation();
    const { otherInfo } = useAuthState();
    const { data, isdCode } = location?.state;
    const [loading, setLoading] = useState(false);
    const [userRec, setUserRec] = useState({});

    useEffect(() => {
        hideMenuTypeTabs(dispatch);
        hideSchoolDrowdown(dispatch);
        return () => {
            showMenuTypeTabs(dispatch);
            showSchoolDrowdown(dispatch);
        }
    }, []);
    const handleCloseRec = () => {
        const { history } = props;
        history.push(`/settings/vendors`);
    }
    const saveRec = async (rec) => {
        const { history } = props;
        const { catererId } = otherInfo;
        if (rec.id == 0) {
            setLoading(true);
            const addRes = await addNewVendorRec({ ...rec, catererId });
            setLoading(false);
            if (!addRes.error) {
                toast.success(addRes.data.message);
                history.push(`/settings/vendors`);

            } else {
                toast.error(addRes.errorMessage);
            }
        } else {
            setLoading(true);
            const saveRes = await saveVendor({ ...rec, catererId });
            setLoading(false);
            if (!saveRes.error) {
                toast.success(saveRes.data.message);
                history.push(`/settings/vendors`);
            } else {
                toast.error(saveRes.errorMessage);
            }
        }
    }

    return (<>
        <Card className='p-4'>
            <CardHeader className='p-2 bg-light'>
                <Row className='align-items-center'>
                    <Col xs={12}><h5>{`Vendor Record`}</h5></Col>
                </Row>
            </CardHeader>
            <CardBody className='p-2'>
                <Row>
                    <Col xs={{
                        offset: 4,
                        size: 4
                    }}>
                        <VendorForm defaultValues={{ ...(data || {}), active: ((data || {}).id || 0) > 0 ? (data || {}).active : true }} {...{ countryCode: (isdCode) }}
                            loading={loading} onCancelClick={async () => {
                                handleCloseRec();
                            }} onSubmitClick={async (data) => {
                                saveRec(data);
                            }} />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    </>);
}
export default VendorRec;